import { useEffect, useState } from 'react';
import { ProductoData } from '../../model/ProductoData';
import { productoDataMapping } from '../../rest/productoDataMapping';
import { get } from '../../rest/api';
import { URL_API_PRODUCTO } from '../../constants/urls';

export const useDetalleData = (codigo?: string) => {
  const [data, setData] = useState<ProductoData | undefined>();
  const [isLoading, setLoading] = useState<boolean>(true);
  const dataError = !isLoading && (!data || (!data.titulo && !data.descripcionDetallada && data.puntos == null));

  const handleResponse = (response: ProductoData | undefined) => {
    if (response) setData(productoDataMapping(response));

    setLoading(false);
  };

  const handleError = () => {
    setData(undefined);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    get(`${URL_API_PRODUCTO}${codigo}`, handleResponse, handleError);
  }, [codigo]);

  return [data, isLoading, dataError] as const;
};
